// extracted by mini-css-extract-plugin
export default {"Change_slide_arrows":"MainSliderArrows_Change_slide_arrows__Z54Lp"};